var global = require('../internals/global');
var hide = require('../internals/hide');

module.exports = function (key, value) {
  try {
    hide(global, key, value);
  } catch (e) {
    global[key] = value;
  } return value;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/set-global.js
// module id = 70
// module chunks = 0